import { PersonListItemType } from '@api';
import { SearchTableInput, Tabs, useManageTableContext } from '@common';
import { AddPersonButton, PersonsOverviewTable } from '@features';
import { Box, Group } from '@mantine/core';
import { PageLayout } from '@pages';
import { useTranslation } from 'react-i18next';

type PersonsPagePropsType = {
  persons: PersonListItemType[];
  isPending: boolean;
};

export const PersonsPage: React.FC<PersonsPagePropsType> = ({
  persons,
  isPending,
}) => {
  const { t } = useTranslation('persons');

  const {
    tableArguments: {
      search: { searchValue, setSearchValue },
    },
  } = useManageTableContext();

  const tabs = [
    {
      label: t('TABS.OVERVIEW'),
      value: 'overview',
    },
  ];

  return (
    <PageLayout title={t('TITLE')}>
      <Tabs value="overview">
        <Tabs.TabsList>
          {tabs.map((tab) => (
            <Tabs.Tab key={tab.value} value={tab.value} to={`/persons`}>
              {tab.label}
            </Tabs.Tab>
          ))}
          <Tabs.TabsListActions>
            <AddPersonButton />
          </Tabs.TabsListActions>
        </Tabs.TabsList>
      </Tabs>
      <Box py="md">
        <Group justify="end" mb="xs">
          <SearchTableInput
            search={searchValue ?? ''}
            setSearchValue={setSearchValue}
            autoFocus
          />
        </Group>
        <PersonsOverviewTable persons={persons} isPending={isPending} />
      </Box>
    </PageLayout>
  );
};
